import React from 'react';
import { C04MultibuttonlayoutCTAProps } from './C04MultibuttonlayoutCTA.types';
import { PromptForMissingDatasource } from 'src/shared/PromptForMissingDatasource';
import { MultiButton } from '@ahc-digital/component-library';
import { GetMultibuttonlayoutCTAModel } from './C04MultibuttonlayoutCTA.service';
import { translationClasses } from 'src/shared/TranslationClasses';
import { useCreateMarketingRenderingHame } from 'src/shared/useCreateMarketingRenderingName';

export const Default = (props?: C04MultibuttonlayoutCTAProps): JSX.Element => {
  const marketingRenderingName = useCreateMarketingRenderingHame(
    props?.rendering?.componentName as string
  );

  if (!props?.rendering?.dataSource)
    return <PromptForMissingDatasource rendering={props?.rendering} />;

  return (
    <MultiButton
      className={translationClasses(props?.params)}
      id={props?.params?.AnchorLinkTargetName}
      data-component={marketingRenderingName}
      {...GetMultibuttonlayoutCTAModel(props)}
    />
  );
};
